import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getFeedSchema, uiSchema, validate } from './Schema';

export default class FeedEditor extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      updatedFeed: cloneDeep(this.props.feed),
    };
  }

  onSubmit = ({ formData }) => {
    this.props.onUpdate(formData);
  };

  render() {
    const { fetching, feedMappings } = this.props;
    const feedTypes = feedMappings.map((mapping) => mapping.type);

    return (
      <div className="form-list-container">
        <Form
          schema={getFeedSchema(this.state.updatedFeed.feedType, feedTypes)}
          uiSchema={uiSchema}
          formData={this.state.updatedFeed}
          onChange={(a) => {
            const feedType = a.formData.feedType;
            const hasFeedTypeChange =
              feedType !== this.state.updatedFeed.feedType;
            this.setState({
              updatedFeed: {
                ...a.formData,
                config: hasFeedTypeChange
                  ? {
                      feedType,
                    }
                  : a.formData.config,
              },
            });
          }}
          validate={validate}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

FeedEditor.propTypes = {
  fetching: PropTypes.bool,
  feed: PropTypes.object,
  feedMappings: PropTypes.array,
  onUpdate: PropTypes.func,
};
